// Logo URLs
export const LOGOS = {
  whiteColored: 'https://customer-assets.emergentagent.com/job_e0817b6f-27ee-4f48-ad5b-3be7756e3e1b/artifacts/ljveo6z8_AC%20Logo%20-%20white%20%26%20coloured.png',
  variation2: 'https://customer-assets.emergentagent.com/job_e0817b6f-27ee-4f48-ad5b-3be7756e3e1b/artifacts/cgx0n15k_AC%20-%20Logo%20variation%202-13.png',
  darkText: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/bggiebwz_AC%20-%20Logo%20variation%202-14.png',
  hrAnexiWhite: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/lum22am1_HR%20Anexi%20White%20logo.png',
  hrAnexi: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/vzcbxn1p_logo%20%2813%29.png',
};

// Client logos for TrustBar
export const CLIENT_LOGOS = [
  {
    name: 'Hindustan Platinum',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/mlqszji3_HP-logo.png',
    alt: 'Hindustan Platinum Logo'
  },
  {
    name: 'BHEL',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/lslnjyj8_BHEL_logo.svg.png',
    alt: 'BHEL Logo'
  },
  {
    name: 'State Bank of India',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/ke4uz3pk_State_Bank_of_India_logo.svg.png',
    alt: 'State Bank of India Logo'
  },
  {
    name: 'Mahendra Brothers',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/cuzzf41u_mahendra_brothers_cover.jpg',
    alt: 'Mahendra Brothers Logo'
  },
  {
    name: 'Jewelex',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/w09tranu_c24c9207-93b1-4d7c-8aaf-a06ee1b6c290%20%281%29.png',
    alt: 'Jewelex Logo'
  },
  {
    name: 'Kumar',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/cdmqwgy5_cropped-kumar-logo.png',
    alt: 'Kumar Logo'
  },
  {
    name: 'Sejal Glass',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/o5bzk745_sejal-logo.png',
    alt: 'Sejal Glass Logo'
  },
  {
    name: 'Nuvama',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/mir0wfzn_Nuvama_Identity_RGB_Positive.fb5f44f17ab40072815e%20%284%29.jpg',
    alt: 'Nuvama Logo'
  },
  {
    name: 'Bajaj Finserv',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/m256uumh_Bajaj_Finserv_Logo.svg.png',
    alt: 'Bajaj Finserv Logo'
  },
  {
    name: 'ADM Group',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/vehvbo3u_adm-group%20%284%29.jpg',
    alt: 'ADM Group Logo'
  },
  {
    name: 'Mehta Tubes Limited',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/hpm3ccrc_logo%20%2814%29.png',
    alt: 'Mehta Tubes Limited Logo'
  },
  {
    name: 'Nykaa',
    url: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/92mnazd7_Nykaa_New_Logo.svg%20%283%29.png',
    alt: 'Nykaa Logo'
  },
];

// Placeholder images
export const PLACEHOLDERS = {
  hero: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80',
  heroAlt: 'https://images.unsplash.com/photo-1497215842964-222b430dc094?w=1920&q=80',
  consulting: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80',
  learning: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&q=80',
  experiences: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=800&q=80',
  firewalk: 'https://images.unsplash.com/photo-1475070929565-c985b576ed36?w=800&q=80',
  engagement: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80',
  technology: 'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&q=80',
  impact: 'https://images.unsplash.com/photo-1510270090250-044bab817bce?w=800&q=80',
  about: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80',
  team: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&q=80',
  teamMale: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80',
  teamFemale: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80',
  office: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80',
  casestudy1: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80',
  casestudy2: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80',
  casestudy3: 'https://images.unsplash.com/photo-1573164574511-73c773193279?w=600&q=80',
  guinness: 'https://images.unsplash.com/photo-1475070929565-c985b576ed36?w=1200&q=80',
};

// Navigation structure
export const NAV_ITEMS = [
  {
    label: 'Consulting',
    href: '/consulting',
    subItems: [
      { label: 'Organisation Design & Structure', href: '/consulting#org-design' },
      { label: 'People Strategy & HR Transformation', href: '/consulting#people-strategy' },
      { label: 'Performance Management Systems', href: '/consulting#performance' },
      { label: 'Rewards & Total Compensation', href: '/consulting#rewards' },
      { label: 'M&A People Integration', href: '/consulting#ma' },
      { label: 'Family Business Advisory', href: '/consulting#family' },
      { label: 'HR Advisory & Outsourcing', href: '/consulting#advisory' },
    ]
  },
  {
    label: 'Learning & Development',
    href: '/learning',
    subItems: [
      { label: 'Leadership Development Program (LDP)', href: '/learning#ldp' },
      { label: 'Management Development Program (MDP)', href: '/learning#mdp' },
      { label: 'Executive Leadership Development', href: '/learning#eldp' },
      { label: 'Femme Phenomenal', href: '/learning#femme' },
      { label: 'Executive Coaching', href: '/learning#coaching' },
      { label: 'FireWalk Experience', href: '/learning#firewalk' },
      { label: 'Glass Walk', href: '/learning#glasswalk' },
      { label: 'The SCBD Lab', href: '/learning#scbd' },
    ]
  },
  {
    label: 'Executive Search',
    href: '/executive-search',
    subItems: [
      { label: 'Retained Search', href: '/executive-search#retained' },
      { label: 'Recruitment Process Outsourcing', href: '/executive-search#rpo' },
    ]
  },
  {
    label: 'Assessments',
    href: '/assessments',
    subItems: [
      { label: 'Psychometric Assessments', href: '/assessments#psychometric' },
      { label: 'Assessment & Development Centres', href: '/assessments#centres' },
    ]
  },
  {
    label: 'Engagement & Research',
    href: '/engagement',
    subItems: [
      { label: 'The X-Model Survey', href: '/engagement#xmodel' },
      { label: 'Employee Engagement Survey', href: '/engagement#engagement' },
      { label: 'Culture & Performance Scans', href: '/engagement#culture' },
      { label: 'HR Audit', href: '/engagement#audit' },
    ]
  },
  {
    label: 'BOTS.AI',
    href: 'https://botsaiconsulting.com/',
    external: true,
    subItems: []
  },
  {
    label: 'Impact',
    href: '/impact',
    subItems: [
      { label: 'Case Studies', href: '/impact#cases' },
      { label: 'Results by the Numbers', href: '/impact#results' },
      { label: 'Client Voices', href: '/impact#voices' },
      { label: 'Guinness World Record', href: '/impact#guinness' },
    ]
  },
  {
    label: 'About',
    href: '/about',
    subItems: [
      { label: 'Our Story', href: '/about#story' },
      { label: 'Leadership Team', href: '/about#team' },
      { label: 'Our Approach', href: '/about#approach' },
      { label: 'Values & Culture', href: '/about#values' },
    ]
  },
];

// Metrics data
export const METRICS = [
  { value: 739, suffix: '+', label: 'Organisations Transformed' },
  { value: 500000, suffix: '+', label: 'Lives Impacted' },
  { value: 100, suffix: '+', label: 'CXOs Placed' },
  { value: 18, suffix: '+', label: 'Years of Impact' },
  { value: 96.4, suffix: '%', label: 'Client Satisfaction', decimals: 1 },
  { value: 1356, suffix: '', label: 'Guinness World Record Firewalkers' },
];

// Capability pillars
export const CAPABILITIES = [
  {
    title: 'Consulting',
    description: 'Strategy that becomes structure. We build organisations, not decks.',
    outcomes: ['Organisation design that sticks', 'HR strategy aligned to business goals', 'M&A integration that retains talent'],
    href: '/consulting',
    icon: 'Building2',
  },
  {
    title: 'Learning & Development',
    description: 'Programs that build leaders, not just skills.',
    outcomes: ['Flagship Leadership Programs', 'Behaviour change, not just knowledge', 'Measurable business impact'],
    href: '/learning',
    icon: 'GraduationCap',
  },
  {
    title: 'Experiences',
    description: 'Beyond theory. Into transformation.',
    outcomes: ['Guinness World Record firewalk', 'Strategic experiential interventions', 'Breakthroughs that last'],
    href: '/experiences',
    icon: 'Flame',
  },
  {
    title: 'Engagement & Research',
    description: 'Hear your people. Move your business.',
    outcomes: ['Proprietary X-Model framework', 'Actionable engagement intelligence', 'Global benchmarking via BOL'],
    href: '/engagement',
    icon: 'BarChart3',
  },
  {
    title: 'BOTS.AI',
    description: 'AI that works with your people, not against them.',
    outcomes: ['AI readiness diagnostics', 'Human-centred AI strategy', 'Change management for AI adoption'],
    href: '/botsai',
    icon: 'Bot',
  },
];

// Case studies
export const CASE_STUDIES = [
  {
    id: 1,
    tag: 'Manufacturing',
    headline: 'Revenue tripled in 3 years',
    client: 'Leading Manufacturing Group',
    service: 'Consulting + L&D',
    description: 'Complete organisation redesign and leadership development that tripled revenue and reduced attrition by 60%.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80',
  },
  {
    id: 2,
    tag: 'Retail',
    headline: 'Attrition crashed from 80% to 28%',
    client: 'National Retail Chain',
    service: 'Engagement + Consulting',
    description: 'Employee engagement survey followed by targeted interventions reduced attrition dramatically.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80',
  },
  {
    id: 3,
    tag: 'AgriTech',
    headline: 'Engagement surged 40 points',
    client: 'AgriTech Pioneer',
    service: 'Engagement + Experiences',
    description: 'Combination of X-Model survey and experiential intervention created lasting cultural transformation.',
    image: 'https://images.unsplash.com/photo-1573164574511-73c773193279?w=600&q=80',
  },
];

// Testimonials
export const TESTIMONIALS = [
  {
    quote: "Anexi doesn't just consult. They build with you. The transformation in our leadership team was visible within months.",
    name: 'Rajesh Mehta',
    title: 'CHRO',
    company: 'Leading Enterprise',
  },
  {
    quote: "The firewalk experience changed how our entire leadership team thinks about limits. It wasn't motivational fluff. It was strategic.",
    name: 'Priya Sharma',
    title: 'CEO',
    company: 'Growth-Stage Company',
  },
  {
    quote: "Their X-Model survey gave us insights we'd never had before. For the first time, we knew exactly where to invest in our people.",
    name: 'Anil Kumar',
    title: 'VP - HR',
    company: 'National Retail Chain',
  },
  {
    quote: "The LDP program transformed not just our managers but our entire culture. We've seen a direct impact on business results.",
    name: 'Kavita Desai',
    title: 'L&D Head',
    company: 'Manufacturing Group',
  },
];

// Leadership team
export const LEADERSHIP_TEAM = [
  { 
    name: 'Dr. Yogish Arora', 
    title: 'CEO, Director', 
    image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/pautmz7o_1740553004794.jpg', 
    bio: 'Dr. Yogish Arora, CEO & Director of Anexi Consulting, leads the firm\'s strategic vision for transforming mid-market and family-run businesses through world-class HR and business consulting. Deep expertise in organizational development and business transformation, he brings innovative leadership methodologies to every engagement. A Guinness World Record holder, Dr. Arora exemplifies the blend of strategic thinking and transformational leadership that defines Anexi Consulting\'s approach.' 
  },
  { name: 'Usha Arora', title: 'Co-Founder, Director', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/saak2fme_1670504846336.jpg', bio: 'Co-Founder and Director of Anexi Consulting, Usha Arora has been the cornerstone of the firm\'s values-driven approach since its inception. With decades of experience in building organizational culture and nurturing client relationships, she brings strategic vision and operational excellence to every engagement. Her leadership has been instrumental in establishing Anexi as a trusted partner for mid-market and family-run businesses across India.' },
  { name: 'Lina Das', title: 'Director, L&OD and Assessment Practice', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/642fjad8_1537342861193%20%281%29.jpg', bio: 'Lina Das serves as Director of the Learning & Organizational Development (L&OD) and Assessment Practice at Anexi Consulting, leading the firm\'s expertise in learning strategy, organizational development, and talent assessment. As a learning strategist, facilitator, and executive coach, Lina brings deep expertise in designing and implementing transformational learning and development programs.' },
  { name: 'Nikhar Arora', title: 'Director & BOTS.AI Practice Head', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/ekirbgrk_1737222347995%20%282%29.jpg', bio: 'Nikhar Arora leads the AI Consulting and Transformation practice at Anexi Consulting, bringing AI-powered innovation to businesses. As co-founder of Mentoria, he has impacted millions of young professionals in career discovery, positioning him as a thought leader on AI\'s transformative impact on careers and the future of work.' },
  { name: 'Vikash Kar', title: 'Associate Director', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/hooj1jyd_image.png', bio: 'Vikash is recognized as a CxO-level management consultant specializing in people strategy and business transformation. Ex-CEO of Zee Learn, Vikash heads the consulting practice at Anexi Consulting. His experience spans multiple industries and organizational sizes, making him a trusted advisor for mid-market companies navigating rapid growth and organizational complexity.' },
  { name: 'Samruddhi Mullye', title: 'Associate Director', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/d9bpi0n6_1723097892720.jpg', bio: 'Samruddhi Mullye is an Associate Director at Anexi Consulting with 22+ years of global HR leadership experience across diverse industries. Recognized as the "Most Fabulous HR Leader in 2020" and winner of the "Fabulous HR Leaders Award," Samruddhi brings world-class HR expertise and proven track record of transforming organizations through strategic HR practices. With experience across multiple industries and geographies, Samruddhi specializes in organizational transformation, HR advisory, and business-HR integration.' },
  { name: 'Ramkumar Venkateswaran', title: 'Vice President', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/tog5eszt_1768905306614.jpg', bio: 'Ramkumar Venkateswaran, CLDP, serves as Vice President at Anexi Consulting, leading the firm\'s strategic expansion into new verticals and markets. With deep expertise in leadership development, people strategy, and business transformation, he drives Anexi Consulting\'s mission to deliver world-class consulting for mid-market and family-run businesses.' },
  { name: 'Carol Pinto', title: 'Content Head', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/ggick32t_1722507830783.jpg', bio: 'Carol Pinto, Content Head for L&OD at Anexi Consulting, brings 15+ years of training content development expertise. Specializing in instructional design and learning program strategy, she creates high-impact content that drives organizational effectiveness and transformation.' },
  { name: 'Ekta Arora', title: 'Sr. Consultant', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/h8yxdu0i_1723483650230.jpg', bio: 'Ekta Arora, Senior Consultant at Anexi Consulting, brings 18+ years of human capital consulting expertise. Specializing in talent assessment, organizational development, and performance management, she translates HR strategy into measurable business results for mid-market organizations.' },
  { name: 'Siddheshwar Natu', title: 'Principal Consultant', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/exr5wi73_1720881671106.jpg', bio: 'Siddheshwar Natu, Principal Consultant at Anexi Consulting, brings 35+ years of L&D strategy and organizational development expertise. Certified in Hogan Assessments and specializing in leadership development, he designs transformational programs that drive organizational effectiveness.' },
  { name: 'Nikhil Mahashabde', title: 'Sr. Consultant', image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/3nhrfeqi_1729425752732.jpg', bio: 'Nikhil Mahashabde, Senior Consultant at Anexi Consulting, brings 17+ years of strategic business solutions and human capital consulting expertise. He leads the Engagement Surveys and Analytics practice at Anexi Consulting.' },
  { name: 'Fronia Gonsalves', title: 'Team Member', image: null, bio: 'Member of the Anexi Consulting team.' },
];

// Founder tribute
export const FOUNDER_TRIBUTE = {
  name: 'Late Dr. Ashish Arora',
  title: 'Founder & Visionary',
  image: 'https://customer-assets.emergentagent.com/job_anexi-consulting/artifacts/5el39m5o_1662101787624.jpg',
  description: 'Dr. Ashish Arora was the visionary founder and Managing Director of HR Anexi, establishing the firm in 2007 as a strategic human capital consulting organization. With deep expertise in organizational development, talent management, and business transformation, he built HR Anexi into a trusted partner while also co-founding Mentoria, an innovative platform that has impacted millions of young professionals in career development.',
  legacy: '35+ years of passion for HR, building businesses, walking on fire, and riding his Harley - we are, because he was.'
};

// Timeline
export const TIMELINE = [
  { year: '2007', title: 'Founded as HR Anexi', description: 'Dr. Ashish Arora establishes HR Anexi in Mumbai with a vision to transform organisations from within.' },
  { year: '2009', title: 'First Major Enterprise Client', description: 'Secured first large-scale consulting engagement, proving the model works at scale.' },
  { year: '2012', title: '100+ Organisations Milestone', description: 'Crossed 100 client organisations across manufacturing, retail, and services sectors.' },
  { year: '2014', title: 'Experiential Learning Launch', description: 'Introduced the firewalk and experiential learning practice, creating a unique differentiator.' },
  { year: '2016', title: 'Guinness World Record', description: '1,356 people walked on fire in a single event, setting a Guinness World Record.' },
  { year: '2018', title: 'X-Model Launch', description: 'Launched the proprietary X-Model employee engagement framework.' },
  { year: '2020', title: 'Digital Transformation', description: 'Pivoted to virtual delivery, expanding reach across India and international markets.' },
  { year: '2022', title: '500+ Organisations', description: 'Crossed 500 client organisations with 96.4% client satisfaction rate.' },
  { year: '2024', title: 'BOTS.AI Practice', description: 'Launched the AI practice, helping organisations navigate AI adoption with human-centred approach.' },
  { year: '2026', title: 'Anexi Consulting Rebrand', description: 'HR Anexi becomes Anexi Consulting, reflecting our expanded scope and 18 years of sustained impact.' },
];

// API config
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;
